import React from "react";
import { defaultState } from "tsi-common-react/src/apps/reviews/defaults";
import { updateFilterOptionValue } from "tsi-common-react/src/apps/reviews/reducers";
import { IReviewQueryFacets } from "tsi-common-react/src/models/reviews";
import {
    useAppDispatch,
    useAppSelector,
} from "tsi-common-react/src/store/reducers";
import { parseFacetValues } from "tsi-common-react/src/utils/reviews";

import { UnstyledSelect } from "../../../components/UnstyledSelect";
// TODO(i18n): Import t for i18n support: import { t } from "ttag";

import { FilterOptions } from "../FilterOptions";

const FACET_TYPE: IReviewQueryFacets = "rating";

export const RatingFilter = () => {
    const dispatch = useAppDispatch();

    const ratingFacet = useAppSelector((state) => {
        const reviewsState = state.reviews || defaultState;
        return (
            reviewsState.data.facets.find(
                (facet) => facet.type === FACET_TYPE,
            ) || null
        );
    });

    const value = useAppSelector((state) => {
        const reviewsState = state.reviews || defaultState;
        const values = parseFacetValues(
            reviewsState.ui.facetValues[FACET_TYPE] || "",
        );
        return values[0] || "";
    });

    const options = ratingFacet ? ratingFacet.options : [];
    return (
        <div className="reviews-region-feel">
            <UnstyledSelect
                noBorder
                className="select select--large-down-arrow review-select"
                value={value}
                onChange={(e) => {
                    const optID = parseInt(e.currentTarget.value, 10) || 0;
                    const isSelected = !!optID;
                    dispatch(
                        updateFilterOptionValue({
                            facetType: FACET_TYPE,
                            optionID: optID,
                            isSelected: isSelected,
                            isExclusive: true,
                        }),
                    );
                }}
            >
                {/* TODO(i18n): Wrap in t tagged template: {t`Rating`} */}
                <option value="" disabled={true}>
                    Rating
                </option>
                {/* TODO(i18n): Wrap in t tagged template: {t`Any`} */}
                <option value="any">Any</option>
                {/* TODO(i18n): Use t with interpolation for complete sentence: getOptionName={(opt) => t`${opt.name} Stars`} */}
                <FilterOptions
                    options={options}
                    getOptionName={(opt) => `${opt.name} Stars`}
                />
            </UnstyledSelect>
        </div>
    );
};
